import { render, staticRenderFns } from "./EnterpriseSubsidiary.vue?vue&type=template&id=b31bf86e"
import script from "./EnterpriseSubsidiary.vue?vue&type=script&lang=js"
export * from "./EnterpriseSubsidiary.vue?vue&type=script&lang=js"
import style0 from "./EnterpriseSubsidiary.vue?vue&type=style&index=0&id=b31bf86e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports